import 'react-toastify/dist/ReactToastify.css';
import { takeLatest, put, call } from "redux-saga/effects";
import { ShowError, ShowSucess } from '../../_helper/helper';

import {
  GET_DEDUCTIONPLANS, GET_DEDUCTIONPLANS_DETAILS, DEDUCTIONPLAN_CREATE, DEDUCTIONPLAN_DELETE,
  DEDUCTIONPLAN_UPDATE,
  GET_DEDUCTION_PLANS_MASTER,
  GET_CURRENT_PAY_PERIOD,
  GET_FUTURE_PAY_PERIODS,
  GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC,
  DEDUCTION_PLAN_CREATE_EMPLOYEE
} from "./actionTypes";

import {
  getDeductionplansSuccess,
  getDeductionplansFail,
  getDeductionplansDetailsSuccess,
  getDeductionplansDetailsFail,
  createDeductionplanSuccess,
  createDeductionplanFail,
  updateDeductionplanSuccess,
  updateDeductionplanFail,
  deleteDeductionplanSuccess,
  deleteDeductionplanFail,
  getDeductionPlanMasterSuccess,
  getDeductionplanMasterFail,
  getCurrentPayPeriodSuccess,
  getFuturePayPeriodListSuccess,
  getFuturePayPeriodListFail,
  getValidationForPayPeriodNetMiscSuccess,
  getValidationForPayPeriodNetMiscFail,
  createDeductionplanForEmployeeSuccess,
  createDeductionplanForEmployeeFail,
} from "./actions";

import {
  createDeductionPlanForEmployeeAPI,
  createDeductionplan, deleteDeductionplan,
  getAllDeductionPlanMaster,
  getCurrentPayPeriodMaster,
  getDeductionplanDetails, getDeductionplans
  , getFuturePayPeriods, getValidateMiscFlagData, updateDeductionplan,
} from "../../_helper/services/deductionplan";
function* onGetDeductionplans({ payload: { page, pageSize } }) {
  try {
    const response = yield call(getDeductionplans, { page, pageSize });
    yield put(getDeductionplansSuccess(response));
  } catch (error) {
    yield put(getDeductionplansFail(error.response));
  }
}

function* onGetAllDeductionplanMaster() {
  try {
    const response = yield call(getAllDeductionPlanMaster);
    yield put(getDeductionPlanMasterSuccess(response));
  } catch (error) {
    yield put(getDeductionplanMasterFail(error.response));
  }
}

function* onGetCurrentPayPeriod() {
  try {
    const response = yield call(getCurrentPayPeriodMaster);
    yield put(getCurrentPayPeriodSuccess(response));
  } catch (error) {
    yield put(getDeductionplanMasterFail(error.response));
  }
}

function* onGetFuturePayPeriods() {
  try {
    const response = yield call(getFuturePayPeriods);
    yield put(getFuturePayPeriodListSuccess(response));
  } catch (error) {
    yield put(getFuturePayPeriodListFail(error.response));
  }
}

function* onGetDeductionplanDetails({ payload: code }) {
  try {
    const response = yield call(getDeductionplanDetails, code);
    yield put(getDeductionplansDetailsSuccess(response));
  } catch (error) {
    yield put(getDeductionplansDetailsFail(error.response));
  }
}

function* onGetValidationForPayPeriod({ payload }) {
  try {
    const response = yield call(getValidateMiscFlagData, payload);
    yield put(getValidationForPayPeriodNetMiscSuccess(response));
  } catch (error) {
    yield put(getValidationForPayPeriodNetMiscFail(error.response));
  }
}

function* onCreateDeductionplanForEmployee({ payload }) {
  try {
    const response = yield call(createDeductionPlanForEmployeeAPI, payload);
    yield put(createDeductionplanForEmployeeSuccess(response));


    if (response?.status == 208) {
      ShowError(`You already have this plan`);
    } else {
      ShowSucess(`${(payload?.id || payload?.Id) ? 'Updated' : 'Created'} successfully`, {
        position: 'top-right'
      });
    }
    return { createResult: response?.data };

  } catch (error) {
    yield put(createDeductionplanForEmployeeFail(error.response));
    ShowError(error?.response?.data?.message);
  }
}

function* onCreateDeductionplan({ payload }) {
  try {
    const response = yield call(createDeductionplan, payload);
    yield put(createDeductionplanSuccess(response));
    ShowSucess('Deductionplan Created successfully', {
      position: 'top-right'
    });

  } catch (error) {
    yield put(createDeductionplanFail(error.response));
    ShowError(error?.response?.data?.message);
  }
}
function* onUpdateDeductionplan({ payload: { code }, payload }) {
  try {
    const response = yield call(updateDeductionplan, code, payload);
    yield put(updateDeductionplanSuccess(response));
    ShowSucess('Deductionplan Details updated successfully', {
      position: 'top-right'
    });
  } catch (error) {
    yield put(updateDeductionplanFail(error.response));
    ShowError(error?.response?.data?.message);
  }
}
function* onDeleteDeductionplan({ payload: code }) {
  try {
    const response = yield call(deleteDeductionplan, code);
    yield put(deleteDeductionplanSuccess(response));
    ShowSucess('Deleted successfully', {
      position: 'top-right'
    });
  } catch (error) {
    yield put(deleteDeductionplanFail(error.response));
    ShowError(error?.response?.data?.message);
  }
}

function* CartSaga() {
  yield takeLatest(GET_DEDUCTIONPLANS, onGetDeductionplans);
  yield takeLatest(GET_DEDUCTION_PLANS_MASTER, onGetAllDeductionplanMaster);
  yield takeLatest(GET_CURRENT_PAY_PERIOD, onGetCurrentPayPeriod);
  yield takeLatest(GET_FUTURE_PAY_PERIODS, onGetFuturePayPeriods);
  yield takeLatest(GET_DEDUCTIONPLANS_DETAILS, onGetDeductionplanDetails);
  yield takeLatest(DEDUCTIONPLAN_CREATE, onCreateDeductionplan);
  yield takeLatest(DEDUCTIONPLAN_UPDATE, onUpdateDeductionplan);
  yield takeLatest(DEDUCTIONPLAN_DELETE, onDeleteDeductionplan);
  yield takeLatest(GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC, onGetValidationForPayPeriod);
  yield takeLatest(DEDUCTION_PLAN_CREATE_EMPLOYEE, onCreateDeductionplanForEmployee);
}

export default CartSaga;